import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import heroTopDesign from "../Images/breadcrumb-design.svg";

const Hero = () => {
  const [startCount, setStartCount] = useState(false);

useEffect(() => {
  const timer = setTimeout(() => {
    setStartCount(true);
  }, 2500);

  return () => clearTimeout(timer);
}, []);

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.25,
      delayChildren: 0.3,
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.4,
      ease: "easeOut",
    },
  },
};

const statContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 1.2,
    },
  },
};

const statItem = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};
  return (
    <section className="hero-section">
        <img
    src={heroTopDesign}
    alt="Dr. Jigar Gor's Ayurveda"
    className="hero-top-design"
  />
      <div className="hero-overlay" />

      <div className="container hero-container">
     <motion.div
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h1
            className="hero-heading"
            variants={fadeUp}
          >
            Natural Healing.
            <br />
            <span>Rooted in Ayurveda.</span>
            <br />
            Focused on You.
          </motion.h1>

          <motion.p
            className="hero-text"
            variants={fadeUp}
          >
            Personalised Ayurvedic treatments to heal the root
            cause, restore balance and transform your life naturally.
          </motion.p>

          <motion.div
            className="hero-btns"
            variants={fadeUp}
          >
            <motion.a
              href="/book-appointment"
              className="primary-btn"
              whileHover={{
                scale: 1.04,
              }}
              transition={{
                duration: 0.4,
              }}
            >
              Book Appointment
            </motion.a>

            <motion.a
               href="https://www.youtube.com/@dr.jigargor.ayurveda"
              target="_blank"
              rel="noopener noreferrer"
              className="secondary-btn"
              whileHover={{
                scale: 1.04,
              }}
              transition={{
                duration: 0.4,
              }}
            >
              Watch Our Story
            </motion.a>
          </motion.div>

          <motion.div
            className="hero-stats"
            variants={statContainer}
          >
            <motion.div
              className="hero-stat"
              variants={statItem}
            >
             <h3>
  {startCount && (
    <CountUp
      end={19}
      duration={3}
    />
  )}
  +
</h3>
              <p>Years of Experience</p>
            </motion.div>

            <motion.div
              className="hero-stat"
              variants={statItem}
            >
            <h3>
  {startCount && (
    <CountUp
      end={25000}
      separator=","
      duration={3}
    />
  )}
  +
</h3>
              <p>Patients Treated</p>
            </motion.div>

            <motion.div
              className="hero-stat"
              variants={statItem}
            >
             <h3>
  {startCount && (
    <CountUp
      end={100}
      duration={3}
    />
  )}
  %
</h3>
              <p>Ayurvedic Treatments</p>
            </motion.div>

            <motion.div
              className="hero-stat"
              variants={statItem}
            >
            <h3>
  {startCount && (
    <CountUp
      end={4.9}
      decimals={1}
      duration={3}
    />
  )}
  /5
</h3>
              <p>Google Rating</p>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;